Ext.define('SA.HistogramModelFactory', {
    singleton: true,

    create({project, censusRelease, name}) {
        var model = new SA.HistogramModel({project, data: {}}),
            country = project.getCountry();

        model.setData({
            barColor: '#80bbff',
            buildingBlocksCensusRelease: censusRelease,
            title: name,
            attribute: this.getFirstSupportedAttribute({project, censusRelease}),
            location: this.getFirstSupportedLocation({project, country, censusRelease}),
            name
        });

        return model;
    },

    getFirstSupportedAttribute({project, censusRelease}) {
        var isSupported = attribute => SA.HistogramAttributes.isSupported({censusRelease, attribute});

        return project.getAttributes().filter(isSupported)[0] || null;
    },

    getFirstSupportedLocation({project, country, censusRelease}) {
        var isSupported = location => SA.HistogramLocations.isSupported({country, censusRelease, location});

        return project.getLocations().filter(isSupported)[0] || null;
    }
});